export const locale = {
    lang: 'en',
    data: {
        PARAMETERS: {
            SEARCH: 'Search parameters',
            SEARCH_TEXT: 'Search...',
            NO_RESULTS: 'No results found',
            PARAMETRE: 'Parameter',
        }
    }
};